import { useQuery } from 'react-query';

import { getBuilderElements } from 'shared/helpers/axios/apis/form-builder.api';

export function useBuilderElements() {
  return useQuery('builder-elements', getBuilderElements, {
    staleTime: Infinity,
  });
}
